import React, { useState, useEffect } from "react";
import { videoGuideList } from "../assets/common";

export default function VideoGuideCarousel({ isOpen, onClose, initialIndex = 0 }) {
    const [currentIndex, setCurrentIndex] = useState(initialIndex);

    // Modal açıldığında seçilen videodan başla
    useEffect(() => {
        if (isOpen) {
            setCurrentIndex(initialIndex);
        }
    }, [isOpen, initialIndex]);

    const handlePrevious = () => {
        setCurrentIndex((prev) =>
            prev === 0 ? videoGuideList.length - 1 : prev - 1
        );
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev + 1) % videoGuideList.length);
    };

    if (!isOpen) return null;

    const currentVideo = videoGuideList[currentIndex];

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center px-4">
            <div className="bg-white rounded-xl w-full max-w-4xl p-6 relative shadow-2xl">
                {/* Enhanced Close Button */}
                <button
                    className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-all duration-200"
                    onClick={onClose}
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                {/* Header with title */}
                <div className="mb-4">
                    <div className="text-xl font-bold text-gray-800">{currentVideo.title}</div>
                </div>

                {/* Video Container */}
                <div className="aspect-video mb-4 rounded-lg overflow-hidden shadow-lg">
                    <iframe
                        className="w-full h-full"
                        src={`https://www.youtube.com/embed/${currentVideo.id}`}
                        title={currentVideo.title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>

                {/* Description */}
                <p className="text-gray-600 mb-6 leading-relaxed">{currentVideo.description}</p>

                {/* Navigation Controls */}
                <div className="flex justify-between items-center">
                    <button
                        onClick={handlePrevious}
                        className="flex items-center gap-2 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-all duration-200 font-medium shadow-sm hover:shadow-md"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                        Önceki
                    </button>

                    {/* Video counter */}
                    <div className="text-sm text-gray-500 bg-gray-50 px-4 py-2 rounded-full">
                        {currentIndex + 1} / {videoGuideList.length}
                    </div>

                    <button
                        onClick={handleNext}
                        className="flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-all duration-200 font-medium shadow-sm hover:shadow-md"
                    >
                        Sonraki
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
}